import customerServiceQA from '@/locales/es/customerServiceQA/customerServiceQA.locales';

export default {
    ...customerServiceQA,
};
